export const campusMapLocationType = {
  building: 1,
  dining: 2,
  location: 3
};
